const KEY = process.env.NEXT_PUBLIC_STRIPE_KEY

export default {
  KEY,
}
